
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("70dwx", function(module, exports) {

$parcel$export(module.exports, "getRandomUniqueNumbers", () => $e8dce92e5ba25285$export$cbb224b90d3f0722);
function $e8dce92e5ba25285$export$cbb224b90d3f0722(count, min, max) {
    const numbers = [];
    while(numbers.length < count){
        const num = Math.floor(Math.random() * (max - min + 1)) + min;
        if (!numbers.includes(num)) numbers.push(num);
    }
    return numbers;
}

});

parcelRegister("27dcx", function(module, exports) {

$parcel$export(module.exports, "default", () => $444a4eb717408c73$export$2e2bcd8739ae039);

var $lyHkj = parcelRequire("lyHkj");

var $eFtsB = parcelRequire("eFtsB");
class $444a4eb717408c73$export$2e2bcd8739ae039 extends (0, $eFtsB.default) {
    constructor(point, cb){
        super();
        new (0, $lyHkj.default).Tween(point).to({
            scale: 1
        }, 300).easing((0, $lyHkj.default).Easing.Elastic.Out).onComplete(()=>cb()).start();
    }
}

});

parcelRegister("6MHFV", function(module, exports) {

$parcel$export(module.exports, "default", () => $a656fd25c1d4e05b$export$2e2bcd8739ae039);

var $lyHkj = parcelRequire("lyHkj");

var $eFtsB = parcelRequire("eFtsB");
class $a656fd25c1d4e05b$export$2e2bcd8739ae039 extends (0, $eFtsB.default) {
    constructor(onUpdate, rotationCount, onComplete){
        super();
        const a = {
            radian: 0
        };
        const targetRadian = rotationCount * (Math.PI * 2);
        new (0, $lyHkj.default).Tween({
            ...a
        }).to({
            radian: targetRadian
        }, 3000).delay(600).easing((0, $lyHkj.default).Easing.Linear.None).onUpdate((a)=>onUpdate(a.radian)).onComplete(()=>onComplete()).start();
    }
}

});

parcelRegister("hP5lc", function(module, exports) {

$parcel$export(module.exports, "default", () => $31aac6c4017c3883$export$2e2bcd8739ae039);

var $lyHkj = parcelRequire("lyHkj");

var $eFtsB = parcelRequire("eFtsB");

var $khzO9 = parcelRequire("khzO9");
class $31aac6c4017c3883$export$2e2bcd8739ae039 extends (0, $eFtsB.default) {
    constructor(sRadian, radian, onUpdate, onComp){
        super();
        const target = (0, $khzO9.shortestAngleDifference)(sRadian, radian) + sRadian;
        const a = {
            radian: sRadian
        };
        new (0, $lyHkj.default).Tween({
            ...a
        }).to({
            radian: target
        }, 1200).easing((0, $lyHkj.default).Easing.Linear.None).onUpdate((a)=>onUpdate(a.radian)).onComplete(()=>onComp()).start();
    }
}

});
parcelRegister("khzO9", function(module, exports) {

$parcel$export(module.exports, "shortestAngleDifference", () => $72df74fcee39458c$export$15665e440adacfed);
function $72df74fcee39458c$var$normalizeAngle(angle) {
    return (angle + Math.PI * 2) % (Math.PI * 2);
}
function $72df74fcee39458c$export$15665e440adacfed(from, to) {
    const a = $72df74fcee39458c$var$normalizeAngle(from);
    const b = $72df74fcee39458c$var$normalizeAngle(to);
    let diff = b - a;
    if (diff > Math.PI) diff -= Math.PI * 2;
    if (diff < -Math.PI) diff += Math.PI * 2;
    return diff;
}

});


parcelRegister("fbGgL", function(module, exports) {

$parcel$export(module.exports, "default", () => $e59d79bdeb13626a$export$2e2bcd8739ae039);

var $2hUu0 = parcelRequire("2hUu0");

var $2Msgp = parcelRequire("2Msgp");
class $e59d79bdeb13626a$export$2e2bcd8739ae039 {
    constructor(cCoord, tags){
        this.center = new (0, $2hUu0.default)("O");
        this.tags = [];
        this.updateCenter = ()=>this.center.updateCoord({
                x: this.cCoord.x + 21,
                y: this.cCoord.y + 21
            });
        this.setAllVisible = (visible)=>[
                this.center,
                ...this.tags
            ].forEach((pTag)=>pTag.visible = visible);
        this.cCoord = cCoord;
        this.tags = tags.map((tag)=>new (0, $2hUu0.default)(tag));
        this.updateCenter();
    }
    updateCoord(radians, radius) {
        const coords = (0, $2Msgp.default)(this.cCoord, radians, radius + 30);
        coords.forEach((coord, cI)=>this.tags[cI].updateCoord(coord));
    }
}

});

parcelRegister("ahQvm", function(module, exports) {

$parcel$export(module.exports, "generateAngles", () => $0afc574e42603e3d$export$adec80d12bc0398e);

var $5ekDK = parcelRequire("5ekDK");

var $g7X8y = parcelRequire("g7X8y");
function $0afc574e42603e3d$export$adec80d12bc0398e(p, clockwise) {
    const { startRadian: startRadian, endRadian: endRadian } = (0, $5ekDK.default)(p.curr, p.prev, p.next);
    const degree = (0, $g7X8y.default)({
        startRadian: startRadian,
        endRadian: endRadian
    }, clockwise, false);
    return {
        startRadian: startRadian,
        endRadian: endRadian,
        degree: degree
    };
}

});
parcelRegister("g7X8y", function(module, exports) {

$parcel$export(module.exports, "default", () => $377d1a2d96ea3eb0$export$2e2bcd8739ae039);

var $2c2c0 = parcelRequire("2c2c0");
function $377d1a2d96ea3eb0$export$2e2bcd8739ae039({ startRadian: startRadian, endRadian: endRadian }, cClockwise, even = true) {
    let _angle = startRadian - endRadian;
    if (!cClockwise) _angle = endRadian - startRadian;
    let degree = Math.floor((0, $2c2c0.default)(_angle));
    degree = degree < 0 ? degree + 360 : degree;
    even && (degree = degree % 2 == 1 ? degree + 1 : degree);
    return degree;
}

});
parcelRegister("2c2c0", function(module, exports) {

$parcel$export(module.exports, "default", () => $0253ba8048e12397$export$2e2bcd8739ae039);
function $0253ba8048e12397$export$2e2bcd8739ae039(radian) {
    return radian * (180 / Math.PI);
}

});



parcelRegister("5yG2B", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f8827fdeed46596$export$2e2bcd8739ae039);
function $9f8827fdeed46596$export$2e2bcd8739ae039(A, B, C) {
    // definate vectors
    const BA = [
        A.x - B.x,
        A.y - B.y
    ];
    const BC = [
        C.x - B.x,
        C.y - B.y
    ];
    // dot product
    const dotProduct = BA[0] * BC[0] + BA[1] * BC[1];
    // dimension of vectors
    const magnitudeBA = Math.hypot(BA[0], BA[1]);
    const magnitudeBC = Math.hypot(BC[0], BC[1]);
    // calc angles as radian
    const angleRad = Math.acos(dotProduct / (magnitudeBA * magnitudeBC));
    const angleDeg = Math.round(Number((angleRad * (180 / Math.PI)).toFixed(2)));
    return angleDeg;
}

});

parcelRegister("hvh3T", function(module, exports) {

$parcel$export(module.exports, "default", () => $2aa69c007d28c008$export$2e2bcd8739ae039);

var $83ZZo = parcelRequire("83ZZo");

var $9e8jK = parcelRequire("9e8jK");

var $4xmXZ = parcelRequire("4xmXZ");
const $2aa69c007d28c008$var$BUTTON_X = 10;
class $2aa69c007d28c008$export$2e2bcd8739ae039 extends $83ZZo.Container {
    constructor(color, handleSwitch, isAddCon = false){
        super(), this.Layers = (0, $9e8jK.default).getInstance(), this.isActive = false, this.addToLayer = ()=>this.Layers.UI.addChild(this), this.getActive = ()=>this.isActive;
        this.handleSwitch = handleSwitch;
        this.greenBg = this.addBg(color);
        this.grayBg = this.addBg(0xDEDEDE);
        this.addButton(0xFFFFFF);
        this.addInteractivity();
        !isAddCon && this.addToLayer();
    }
    addBg(color) {
        const bgBound = {
            width: 40,
            height: 20
        };
        const bg = new $83ZZo.Graphics().clear().roundRect(-bgBound.width / 2, -bgBound.height / 2, bgBound.width, bgBound.height).fill(color);
        this.addChild(bg);
        return bg;
    }
    handleSwitchButton() {
        this.isActive = !this.isActive;
        this.handleSwitch(this.isActive);
        new (0, $4xmXZ.default)(this);
    }
    addInteractivity() {
        this.interactive = true;
        this.cursor = "pointer";
        this.on("mouseup", ()=>this.handleSwitchButton());
        this.on("touchend", ()=>this.handleSwitchButton());
    }
    setActive(v) {
        this.grayBg.alpha = this.isActive ? 1 - v : v;
        this.greenBg.alpha = this.isActive ? v : 1 - v;
        this.button.x = this.isActive ? 2 * $2aa69c007d28c008$var$BUTTON_X * v : 2 * $2aa69c007d28c008$var$BUTTON_X * (1 - v);
    }
    addButton(color) {
        this.button = new $83ZZo.Graphics().circle(-$2aa69c007d28c008$var$BUTTON_X, 0, 8).fill(color);
        this.addChild(this.button);
    }
}

});
parcelRegister("4xmXZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $17774a77c2e12c3a$export$2e2bcd8739ae039);

var $lyHkj = parcelRequire("lyHkj");

var $eFtsB = parcelRequire("eFtsB");
class $17774a77c2e12c3a$export$2e2bcd8739ae039 extends (0, $eFtsB.default) {
    constructor(Switcher){
        super();
        const alpha = 0;
        new (0, $lyHkj.default).Tween({
            alpha: alpha
        }).to({
            alpha: 1
        }, 500).easing((0, $lyHkj.default).Easing.Linear.None).onUpdate(({ alpha: alpha })=>{
            Switcher.setActive(alpha);
        }).start();
    }
}

});


parcelRegister("l5XQj", function(module, exports) {

$parcel$export(module.exports, "default", () => $ecc2fbd6d7a64bc4$export$2e2bcd8739ae039);

var $83ZZo = parcelRequire("83ZZo");

var $9e8jK = parcelRequire("9e8jK");
class $ecc2fbd6d7a64bc4$export$2e2bcd8739ae039 extends $83ZZo.Container {
    constructor(title, style, handleFunc){
        super(), this.Layers = (0, $9e8jK.default).getInstance(), this.addToLayer = ()=>this.Layers.UI.addChild(this);
        this.style = style;
        this.titleText = title;
        this.handleFunc = handleFunc;
        this.addBg(style);
        this.addTitle(title, style.titleColor);
        this.handleEvents();
        this.addToLayer();
    }
    handleEvents() {
        this.interactive = true;
        this.cursor = "pointer";
        const pressedFunc = ()=>{
            this.drawBg(this.style, this.style.pressedColor);
            this.handleFunc();
        };
        this.on("mouseover", ()=>this.drawBg(this.style, this.style.hoverColor));
        this.on("mouseup", ()=>this.drawBg(this.style, this.style.hoverColor));
        this.on("mouseleave", ()=>this.drawBg(this.style, this.style.defaultColor));
        this.on("mousedown", ()=>pressedFunc());
        this.on("touchstart", ()=>pressedFunc());
        this.on("touchend", ()=>this.drawBg(this.style, this.style.defaultColor));
    }
    addTitle(title, color) {
        this.title = new $83ZZo.Text({
            text: title
        });
        this.title.style = {
            fill: color,
            fontSize: this.style.titleFontSize,
            wordWrap: true,
            wordWrapWidth: this.style.wordWrapWidth,
            align: "center"
        };
        this.title.anchor.set(.5);
        this.addChild(this.title);
    }
    addBg(style) {
        this.bg = new $83ZZo.Graphics();
        this.addChild(this.bg);
        this.drawBg(style, style.defaultColor);
    }
    drawBg(style, color) {
        this.bg.clear();
        this.bg.roundRect(-style.width / 2, -style.height / 2, style.width, style.height, style.borderRadius).stroke({
            width: 5,
            color: style.borderColor
        }).fill(color);
    }
    handleTitle(title, color) {
        this.titleText = title;
        this.title.text = title;
        this.title.style.fill = color;
    }
}

});

parcelRegister("htSjE", function(module, exports) {

$parcel$export(module.exports, "getTextureBatchBindGroup", () => $e6d9114a2720969b$export$84c26df82650dc9b);

var $dcKRv = parcelRequire("dcKRv");

var $7Ix7i = parcelRequire("7Ix7i");
"use strict";
const $e6d9114a2720969b$var$cachedGroups = {};
function $e6d9114a2720969b$export$84c26df82650dc9b(textures, size, maxTextures) {
    let uid = 2166136261;
    for(let i = 0; i < size; i++){
        uid ^= textures[i].uid;
        uid = Math.imul(uid, 16777619);
        uid >>>= 0;
    }
    return $e6d9114a2720969b$var$cachedGroups[uid] || $e6d9114a2720969b$var$generateTextureBatchBindGroup(textures, size, uid, maxTextures);
}
function $e6d9114a2720969b$var$generateTextureBatchBindGroup(textures, size, key, maxTextures) {
    const bindGroupResources = {};
    let bindIndex = 0;
    for(let i = 0; i < maxTextures; i++){
        const texture = i < size ? textures[i] : (0, $7Ix7i.Texture).EMPTY.source;
        bindGroupResources[bindIndex++] = texture.source;
        bindGroupResources[bindIndex++] = texture.style;
    }
    const bindGroup = new (0, $dcKRv.BindGroup)(bindGroupResources);
    $e6d9114a2720969b$var$cachedGroups[key] = bindGroup;
    return bindGroup;
}

});

parcelRegister("e9jtq", function(module, exports) {

$parcel$export(module.exports, "CanvasPool", () => $31a4fb027e026d19$export$e56d0a06781accc9);

var $aY7HM = parcelRequire("aY7HM");

var $hVXXe = parcelRequire("hVXXe");
"use strict";
class $31a4fb027e026d19$export$62d9f0b8aada09d7 {
    constructor(canvasOptions){
        this._canvasPool = /* @__PURE__ */ Object.create(null);
        this.canvasOptions = canvasOptions || {};
        this.enableFullScreen = false;
    }
    /**
   * Creates texture with params that were specified in pool constructor.
   * @param pixelWidth - Width of texture in pixels.
   * @param pixelHeight - Height of texture in pixels.
   */ _createCanvasAndContext(pixelWidth, pixelHeight) {
        const canvas = (0, $aY7HM.DOMAdapter).get().createCanvas();
        canvas.width = pixelWidth;
        canvas.height = pixelHeight;
        const context = canvas.getContext("2d");
        return {
            canvas: canvas,
            context: context
        };
    }
    /**
   * Gets a Power-of-Two render texture or fullScreen texture
   * @param minWidth - The minimum width of the render texture.
   * @param minHeight - The minimum height of the render texture.
   * @param resolution - The resolution of the render texture.
   * @returns The new render texture.
   */ getOptimalCanvasAndContext(minWidth, minHeight, resolution = 1) {
        minWidth = Math.ceil(minWidth * resolution - 1e-6);
        minHeight = Math.ceil(minHeight * resolution - 1e-6);
        minWidth = (0, $hVXXe.nextPow2)(minWidth);
        minHeight = (0, $hVXXe.nextPow2)(minHeight);
        const key = (minWidth << 17) + (minHeight << 1);
        if (!this._canvasPool[key]) this._canvasPool[key] = [];
        let canvasAndContext = this._canvasPool[key].pop();
        if (!canvasAndContext) canvasAndContext = this._createCanvasAndContext(minWidth, minHeight);
        return canvasAndContext;
    }
    /**
   * Place a render texture back into the pool.
   * @param canvasAndContext
   */ returnCanvasAndContext(canvasAndContext) {
        const canvas = canvasAndContext.canvas;
        const { width: width, height: height } = canvas;
        const key = (width << 17) + (height << 1);
        canvasAndContext.context.clearRect(0, 0, width, height);
        this._canvasPool[key].push(canvasAndContext);
    }
    clear() {
        this._canvasPool = {};
    }
}
const $31a4fb027e026d19$export$e56d0a06781accc9 = new $31a4fb027e026d19$export$62d9f0b8aada09d7();

});

parcelRegister("bRPvq", function(module, exports) {

$parcel$export(module.exports, "AbstractRenderer", () => $7c1ba3270bd37f6d$export$58ab3ed211eed562);

var $36Ltv = parcelRequire("36Ltv");

var $gHh6O = parcelRequire("gHh6O");

var $d7k7b = parcelRequire("d7k7b");

var $2RIEa = parcelRequire("2RIEa");

var $fdcJR = parcelRequire("fdcJR");

var $1Ki8H = parcelRequire("1Ki8H");


var $9W01S = parcelRequire("9W01S");

var $anqU0 = parcelRequire("anqU0");

var $98bME = parcelRequire("98bME");
"use strict";
const $7c1ba3270bd37f6d$var$defaultRunners = [
    "init",
    "destroy",
    "contextChange",
    "resolutionChange",
    "resetState",
    "renderEnd",
    "renderStart",
    "render",
    "update",
    "postrender",
    "prerender"
];
const $7c1ba3270bd37f6d$var$_AbstractRenderer = class _AbstractRenderer extends (0, (/*@__PURE__*/$parcel$interopDefault($98bME))) {
    /**
   * Set up a system with a collection of SystemClasses and runners.
   * Systems are attached dynamically to this class when added.
   * @param config - the config for the system manager
   */ constructor(config){
        super();
        /** @internal */ this.uid = (0, $fdcJR.uid)("renderer");
        /** @internal */ this.runners = /* @__PURE__ */ Object.create(null);
        /** @internal */ this.renderPipes = /* @__PURE__ */ Object.create(null);
        this._initOptions = {};
        this._systemsHash = /* @__PURE__ */ Object.create(null);
        this.type = config.type;
        this.name = config.name;
        this.config = config;
        const combinedRunners = [
            ...$7c1ba3270bd37f6d$var$defaultRunners,
            ...this.config.runners ?? []
        ];
        this._addRunners(...combinedRunners);
        this._unsafeEvalCheck();
    }
    /**
   * Initialize the renderer.
   * @param options - The options to use to create the renderer.
   */ async init(options = {}) {
        const skip = options.skipExtensionImports === true ? true : options.manageImports === false;
        await (0, $gHh6O.loadEnvironmentExtensions)(skip);
        this._addSystems(this.config.systems);
        this._addPipes(this.config.renderPipes, this.config.renderPipeAdaptors);
        for(const systemName in this._systemsHash){
            const system = this._systemsHash[systemName];
            const defaultSystemOptions = system.constructor.defaultOptions;
            options = {
                ...defaultSystemOptions,
                ...options
            };
        }
        options = {
            ..._AbstractRenderer.defaultOptions,
            ...options
        };
        this._roundPixels = options.roundPixels ? 1 : 0;
        for(let i = 0; i < this.runners.init.items.length; i++)await this.runners.init.items[i].init(options);
        this._initOptions = options;
    }
    render(args, deprecated) {
        let options = args;
        if (options instanceof (0, $d7k7b.Container)) {
            options = {
                container: options
            };
            if (deprecated) {
                (0, $1Ki8H.deprecation)((0, $1Ki8H.v8_0_0), "passing a second argument is deprecated, please use render options instead");
                options.target = deprecated.renderTexture;
            }
        }
        options.target || (options.target = this.view.renderTarget);
        if (options.target === this.view.renderTarget) {
            this._lastObjectRendered = options.container;
            options.clearColor ?? (options.clearColor = this.background.colorRgba);
            options.clear ?? (options.clear = this.background.clearBeforeRender);
        }
        if (options.clearColor) {
            const isRGBAArray = Array.isArray(options.clearColor) && options.clearColor.length === 4;
            options.clearColor = isRGBAArray ? options.clearColor : (0, $36Ltv.Color).shared.setValue(options.clearColor).toArray();
        }
        if (!options.transform) {
            options.container.updateLocalTransform();
            options.transform = options.container.localTransform;
        }
        options.container.enableRenderGroup();
        this.runners.prerender.emit(options);
        this.runners.renderStart.emit(options);
        this.runners.render.emit(options);
        this.runners.renderEnd.emit(options);
        this.runners.postrender.emit(options);
    }
    /**
   * Resizes the WebGL view to the specified width and height.
   * @param desiredScreenWidth - The desired width of the screen.
   * @param desiredScreenHeight - The desired height of the screen.
   * @param resolution - The resolution / device pixel ratio of the renderer.
   */ resize(desiredScreenWidth, desiredScreenHeight, resolution) {
        const previousResolution = this.view.resolution;
        this.view.resize(desiredScreenWidth, desiredScreenHeight, resolution);
        this.emit("resize", this.view.screen.width, this.view.screen.height, this.view.resolution);
        if (resolution !== void 0 && resolution !== previousResolution) this.runners.resolutionChange.emit(resolution);
    }
    /**
   * Clears the render target.
   * @param options - The options to use when clearing the render target.
   * @param options.target - The render target to clear.
   * @param options.clearColor - The color to clear with.
   * @param options.clear - The clear mode to use.
   * @advanced
   */ clear(options = {}) {
        const renderer = this;
        options.target || (options.target = renderer.renderTarget.renderTarget);
        options.clearColor || (options.clearColor = this.background.colorRgba);
        options.clear ?? (options.clear = (0, $9W01S.CLEAR).ALL);
        const { clear: clear, clearColor: clearColor, target: target } = options;
        (0, $36Ltv.Color).shared.setValue(clearColor ?? this.background.colorRgba);
        renderer.renderTarget.clear(target, clear, (0, $36Ltv.Color).shared.toArray());
    }
    /** The resolution / device pixel ratio of the renderer. */ get resolution() {
        return this.view.resolution;
    }
    set resolution(value) {
        this.view.resolution = value;
        this.runners.resolutionChange.emit(value);
    }
    /**
   * Same as view.width, actual number of pixels in the canvas by horizontal.
   * @type {number}
   * @readonly
   * @default 800
   */ get width() {
        return this.view.texture.frame.width;
    }
    /**
   * Same as view.height, actual number of pixels in the canvas by vertical.
   * @default 600
   */ get height() {
        return this.view.texture.frame.height;
    }
    // NOTE: this was `view` in v7
    /**
   * The canvas element that everything is drawn to.
   * @type {environment.ICanvas}
   */ get canvas() {
        return this.view.canvas;
    }
    /**
   * the last object rendered by the renderer. Useful for other plugins like interaction managers
   * @readonly
   */ get lastObjectRendered() {
        return this._lastObjectRendered;
    }
    /**
   * Flag if we are rendering to the screen vs renderTexture
   * @readonly
   * @default true
   */ get renderingToScreen() {
        const renderer = this;
        return renderer.renderTarget.renderingToScreen;
    }
    /**
   * Measurements of the screen. (0, 0, screenWidth, screenHeight).
   *
   * Its safe to use as filterArea or hitArea for the whole stage.
   */ get screen() {
        return this.view.screen;
    }
    /**
   * Create a bunch of runners based of a collection of ids
   * @param runnerIds - the runner ids to add
   */ _addRunners(...runnerIds) {
        runnerIds.forEach((runnerId)=>{
            this.runners[runnerId] = new (0, $anqU0.SystemRunner)(runnerId);
        });
    }
    _addSystems(systems) {
        let i;
        for(i in systems){
            const val = systems[i];
            this._addSystem(val.value, val.name);
        }
    }
    /**
   * Add a new system to the renderer.
   * @param ClassRef - Class reference
   * @param name - Property name for system, if not specified
   *        will use a static `name` property on the class itself. This
   *        name will be assigned as s property on the Renderer so make
   *        sure it doesn't collide with properties on Renderer.
   * @returns Return instance of renderer
   */ _addSystem(ClassRef, name) {
        const system = new ClassRef(this);
        if (this[name]) throw new Error(`Whoops! The name "${name}" is already in use`);
        this[name] = system;
        this._systemsHash[name] = system;
        for(const i in this.runners)this.runners[i].add(system);
        return this;
    }
    _addPipes(pipes, pipeAdaptors) {
        const adaptors = pipeAdaptors.reduce((acc, adaptor)=>{
            acc[adaptor.name] = adaptor.value;
            return acc;
        }, {});
        pipes.forEach((pipe)=>{
            const PipeClass = pipe.value;
            const name = pipe.name;
            const Adaptor = adaptors[name];
            this.renderPipes[name] = new PipeClass(this, Adaptor ? new Adaptor() : null);
        });
    }
    destroy(options = false) {
        this.runners.destroy.items.reverse();
        this.runners.destroy.emit(options);
        Object.values(this.runners).forEach((runner)=>{
            runner.destroy();
        });
        this._systemsHash = null;
        this.renderPipes = null;
    }
    /**
   * Generate a texture from a container.
   * @param options - options or container target to use when generating the texture
   * @returns a texture
   */ generateTexture(options) {
        return this.textureGenerator.generateTexture(options);
    }
    /**
   * Whether the renderer will round coordinates to whole pixels when rendering.
   * Can be overridden on a per scene item basis.
   */ get roundPixels() {
        return !!this._roundPixels;
    }
    /**
   * Overridable function by `pixi.js/unsafe-eval` to silence
   * throwing an error if platform doesn't support unsafe-evals.
   * @private
   * @ignore
   */ _unsafeEvalCheck() {
        if (!(0, $2RIEa.unsafeEvalSupported)()) throw new Error("Current environment does not allow unsafe-eval, please use pixi.js/unsafe-eval module to enable support.");
    }
    /**
   * Resets the rendering state of the renderer.
   * This is useful when you want to use the WebGL context directly and need to ensure PixiJS's internal state
   * stays synchronized. When modifying the WebGL context state externally, calling this method before the next Pixi
   * render will reset all internal caches and ensure it executes correctly.
   *
   * This is particularly useful when combining PixiJS with other rendering engines like Three.js:
   * ```js
   * // Reset Three.js state
   * threeRenderer.resetState();
   *
   * // Render a Three.js scene
   * threeRenderer.render(threeScene, threeCamera);
   *
   * // Reset PixiJS state since Three.js modified the WebGL context
   * pixiRenderer.resetState();
   *
   * // Now render Pixi content
   * pixiRenderer.render(pixiScene);
   * ```
   * @advanced
   */ resetState() {
        this.runners.resetState.emit();
    }
};
/** The default options for the renderer. */ $7c1ba3270bd37f6d$var$_AbstractRenderer.defaultOptions = {
    /**
   * Default resolution / device pixel ratio of the renderer.
   * @default 1
   */ resolution: 1,
    /**
   * Should the `failIfMajorPerformanceCaveat` flag be enabled as a context option used in the `isWebGLSupported`
   * function. If set to true, a WebGL renderer can fail to be created if the browser thinks there could be
   * performance issues when using WebGL.
   *
   * In PixiJS v6 this has changed from true to false by default, to allow WebGL to work in as many
   * scenarios as possible. However, some users may have a poor experience, for example, if a user has a gpu or
   * driver version blacklisted by the
   * browser.
   *
   * If your application requires high performance rendering, you may wish to set this to false.
   * We recommend one of two options if you decide to set this flag to false:
   *
   * 1: Use the Canvas renderer as a fallback in case high performance WebGL is
   *    not supported.
   *
   * 2: Call `isWebGLSupported` (which if found in the utils package) in your code before attempting to create a
   *    PixiJS renderer, and show an error message to the user if the function returns false, explaining that their
   *    device & browser combination does not support high performance WebGL.
   *    This is a much better strategy than trying to create a PixiJS renderer and finding it then fails.
   * @default false
   */ failIfMajorPerformanceCaveat: false,
    /**
   * Should round pixels be forced when rendering?
   * @default false
   */ roundPixels: false
};
let $7c1ba3270bd37f6d$export$58ab3ed211eed562 = $7c1ba3270bd37f6d$var$_AbstractRenderer;

});
parcelRegister("gHh6O", function(module, exports) {

$parcel$export(module.exports, "loadEnvironmentExtensions", () => $73b7dba69a4e9a90$export$3b30260a318c769f);

var $cMikx = parcelRequire("cMikx");
"use strict";
const $73b7dba69a4e9a90$var$environments = [];
(0, $cMikx.extensions).handleByNamedList((0, $cMikx.ExtensionType).Environment, $73b7dba69a4e9a90$var$environments);
async function $73b7dba69a4e9a90$export$3b30260a318c769f(skip) {
    if (skip) return;
    for(let i = 0; i < $73b7dba69a4e9a90$var$environments.length; i++){
        const env = $73b7dba69a4e9a90$var$environments[i];
        if (env.value.test()) {
            await env.value.load();
            return;
        }
    }
}
async function $73b7dba69a4e9a90$export$72225172dd907279(add) {
    return $73b7dba69a4e9a90$export$3b30260a318c769f(!add);
}

});

parcelRegister("2RIEa", function(module, exports) {

$parcel$export(module.exports, "unsafeEvalSupported", () => $7aebd45fef6bbf9b$export$70c0711f29adc5cf);
"use strict";
let $7aebd45fef6bbf9b$var$unsafeEval;
function $7aebd45fef6bbf9b$export$70c0711f29adc5cf() {
    if (typeof $7aebd45fef6bbf9b$var$unsafeEval === "boolean") return $7aebd45fef6bbf9b$var$unsafeEval;
    try {
        const func = new Function("param1", "param2", "param3", "return param1[param2] === param3;");
        $7aebd45fef6bbf9b$var$unsafeEval = func({
            a: "b"
        }, "a", "b") === true;
    } catch (_e) {
        $7aebd45fef6bbf9b$var$unsafeEval = false;
    }
    return $7aebd45fef6bbf9b$var$unsafeEval;
}

});

parcelRegister("9W01S", function(module, exports) {

$parcel$export(module.exports, "CLEAR", () => $019d7ae2ae677ac1$export$6c4d37c7f376a1de);
"use strict";
var $019d7ae2ae677ac1$export$6c4d37c7f376a1de = /* @__PURE__ */ ((CLEAR2)=>{
    CLEAR2[CLEAR2["NONE"] = 0] = "NONE";
    CLEAR2[CLEAR2["COLOR"] = 16384] = "COLOR";
    CLEAR2[CLEAR2["STENCIL"] = 1024] = "STENCIL";
    CLEAR2[CLEAR2["DEPTH"] = 256] = "DEPTH";
    CLEAR2[CLEAR2["COLOR_DEPTH"] = 16640] = "COLOR_DEPTH";
    CLEAR2[CLEAR2["COLOR_STENCIL"] = 17408] = "COLOR_STENCIL";
    CLEAR2[CLEAR2["DEPTH_STENCIL"] = 1280] = "DEPTH_STENCIL";
    CLEAR2[CLEAR2["ALL"] = 17664] = "ALL";
    return CLEAR2;
})($019d7ae2ae677ac1$export$6c4d37c7f376a1de || {});

});

parcelRegister("anqU0", function(module, exports) {

$parcel$export(module.exports, "SystemRunner", () => $27d711bf58994fc3$export$ff5f2fe687fe3979);
"use strict";
class $27d711bf58994fc3$export$ff5f2fe687fe3979 {
    /**
   * @param name - The function name that will be executed on the listeners added to this Runner.
   */ constructor(name){
        this.items = [];
        this._name = name;
    }
    /* jsdoc/check-param-names */ /**
   * Dispatch/Broadcast Runner to all listeners added to the queue.
   * @param {...any} params - (optional) parameters to pass to each listener
   */ /* jsdoc/check-param-names */ emit(a0, a1, a2, a3, a4, a5, a6, a7) {
        const { name: name, items: items } = this;
        for(let i = 0, len = items.length; i < len; i++)items[i][name](a0, a1, a2, a3, a4, a5, a6, a7);
        return this;
    }
    /**
   * Add a listener to the Runner
   *
   * Runners do not need to have scope or functions passed to them.
   * All that is required is to pass the listening object and ensure that it has contains a function that has the same name
   * as the name provided to the Runner when it was created.
   *
   * Eg A listener passed to this Runner will require a 'complete' function.
   *
   * ```ts
   * import { Runner } from 'pixi.js';
   *
   * const complete = new Runner('complete');
   * ```
   *
   * The scope used will be the object itself.
   * @param {any} item - The object that will be listening.
   */ add(item) {
        if (item[this._name]) {
            this.remove(item);
            this.items.push(item);
        }
        return this;
    }
    /**
   * Remove a single listener from the dispatch queue.
   * @param {any} item - The listener that you would like to remove.
   */ remove(item) {
        const index = this.items.indexOf(item);
        if (index !== -1) this.items.splice(index, 1);
        return this;
    }
    /**
   * Check to see if the listener is already in the Runner
   * @param {any} item - The listener that you would like to check.
   */ contains(item) {
        return this.items.indexOf(item) !== -1;
    }
    /** Remove all listeners from the Runner */ removeAll() {
        this.items.length = 0;
        return this;
    }
    /** Remove all references, don't use after this. */ destroy() {
        this.removeAll();
        this.items = null;
        this._name = null;
    }
    /**
   * `true` if there are no this Runner contains no listeners
   * @readonly
   */ get empty() {
        return this.items.length === 0;
    }
    /**
   * The name of the runner.
   * @readonly
   */ get name() {
        return this._name;
    }
}

});


parcelRegister("AFJYy", function(module, exports) {

$parcel$export(module.exports, "ApplicationInitHook", () => $00c29f6d2290dcd3$export$918f3e4d2b801859);
$parcel$export(module.exports, "RendererInitHook", () => $00c29f6d2290dcd3$export$5fba6e443d2fb64);

var $cMikx = parcelRequire("cMikx");

var $a02t4 = parcelRequire("a02t4");
"use strict";
class $00c29f6d2290dcd3$export$918f3e4d2b801859 {
    static init() {
        globalThis.__PIXI_APP_INIT__?.(this, (0, $a02t4.VERSION));
    }
    static destroy() {}
}
/** @ignore */ $00c29f6d2290dcd3$export$918f3e4d2b801859.extension = (0, $cMikx.ExtensionType).Application;
class $00c29f6d2290dcd3$export$5fba6e443d2fb64 {
    constructor(renderer){
        this._renderer = renderer;
    }
    init() {
        globalThis.__PIXI_RENDERER_INIT__?.(this._renderer, (0, $a02t4.VERSION));
    }
    destroy() {
        this._renderer = null;
    }
}
/** @ignore */ $00c29f6d2290dcd3$export$5fba6e443d2fb64.extension = {
    type: [
        (0, $cMikx.ExtensionType).WebGLSystem,
        (0, $cMikx.ExtensionType).WebGPUSystem
    ],
    name: "initHook",
    priority: -10
};

});
parcelRegister("a02t4", function(module, exports) {

$parcel$export(module.exports, "VERSION", () => $840423e2c9afffc1$export$a4ad2735b021c132);

var $98bME = parcelRequire("98bME");
"use strict";
const $840423e2c9afffc1$export$dbafa72958753fce = /^\s*data:(?:([\w-]+)\/([\w+.-]+))?(?:;charset=([\w-]+))?(?:;(base64))?,(.*)/i;
const $840423e2c9afffc1$export$a4ad2735b021c132 = "8.10.1";

});



var $d55ji = parcelRequire("d55ji");

var $d55ji = parcelRequire("d55ji");

var $jG160 = parcelRequire("jG160");

var $dF6vz = parcelRequire("dF6vz");

var $6DjBJ = parcelRequire("6DjBJ");

var $2wguv = parcelRequire("2wguv");
const $3e175ec0bdd08ea5$export$64436d1175f556d9 = {
    angle1: "a",
    angle2: "b",
    angle3: "c",
    angle4: "d"
};
const $3e175ec0bdd08ea5$export$853e2ffa6cb8f5fa = [
    0xFC99C4,
    0x21D4FE,
    0xf94f6f,
    0x0195b8
];
const $3e175ec0bdd08ea5$export$ca8f2c484d507a5d = 200;
const $3e175ec0bdd08ea5$export$6d492146c93bd459 = [
    Math.PI / 18 * 13,
    Math.PI / 9 * 2,
    -Math.PI / 9,
    -Math.PI / 6 * 5
];
const $3e175ec0bdd08ea5$export$c7609d9da8d80867 = {
    x: 600,
    y: 310
};
const $3e175ec0bdd08ea5$export$186dbbe504e85fe1 = [
    {
        x: 420,
        y: 800
    },
    {
        x: 810,
        y: 800
    }
];
const $3e175ec0bdd08ea5$export$75f2cc8245aafe09 = [
    {
        x: 60,
        y: 400
    },
    {
        x: 60,
        y: 400
    }
];
const $3e175ec0bdd08ea5$export$1312ecbb29a79419 = {
    x: 195,
    y: 800
};
const $3e175ec0bdd08ea5$export$840ec2322406bfdd = {
    x: 1180,
    y: 200
};
const $3e175ec0bdd08ea5$export$190b4c043fb6edf4 = {
    x: 1500,
    y: 800
};
const $3e175ec0bdd08ea5$export$f64a627e96c12fc8 = [
    {
        x: 750,
        y: 620
    },
    {
        x: 750,
        y: 670
    }
];
const $3e175ec0bdd08ea5$export$619d8bee3d0fdc47 = [
    [
        {
            x: 40,
            y: 400
        },
        {
            x: 40,
            y: 350
        },
        {
            x: 100,
            y: 400
        },
        {
            x: 100,
            y: 350
        }
    ],
    [
        {
            x: 200,
            y: 400
        },
        {
            x: 200,
            y: 350
        },
        {
            x: 200,
            y: 400
        },
        {
            x: 200,
            y: 350
        }
    ]
];
const $3e175ec0bdd08ea5$export$4697ad01a4a84996 = [
    "/circle-theorem-2/info-slider/1.jpeg",
    "/circle-theorem-2/info-slider/2.jpeg",
    "/circle-theorem-2/info-slider/3.jpeg",
    "/circle-theorem-2/info-slider/4.jpeg",
    "/circle-theorem-2/info-slider/5.jpeg",
    "/circle-theorem-2/info-slider/6.jpeg"
];



var $83ZZo = parcelRequire("83ZZo");
var $cab198783107b617$export$cb883390c27ec6dd = /*#__PURE__*/ function(EnumEventBus) {
    EnumEventBus["setCalcLines"] = "SET_CALC_LINES";
    EnumEventBus["showCalcLine"] = "SHOW_CALCULATION_LINE";
    EnumEventBus["setGrowCircleValue"] = "SET_GROW_CIRCLE_VALUE";
    EnumEventBus["setCentralValue"] = "SET_CENTRAL_SLIDER_VALUE";
    EnumEventBus["setRotCircleValue"] = "SET_ROTATE_CIRCLE_VALUE";
    EnumEventBus["setRadiansToRefs"] = "SET_RADIAN_PARAMS_TO_RADIAN_REFERANCE_PARAMS";
    EnumEventBus["setCalcForAnim"] = "SET_CALCULATION_LINE_FOR_ANIMATION";
    EnumEventBus["showSliders"] = "SHOW_SLIDERS";
    EnumEventBus["drawElements"] = "DRAW_ELEMENTS";
    EnumEventBus["generateRandomQuadri"] = "GENERATE_RANDOM_QUADRILATERAL";
    EnumEventBus["movePoints"] = "MOVE_POINTS";
    EnumEventBus["supplementaryMode"] = "SUPPLEMENTARY_MODE";
    EnumEventBus["setElementsForAnim"] = "SET_ELEMENTS_FOR_ANIMATION";
    EnumEventBus["setPointChecklist"] = "SET_POINT_CHECK_LIST";
    return EnumEventBus;
}({});
const $cab198783107b617$export$5087227eb54526 = new (0, $83ZZo.EventEmitter)();



var $70dwx = parcelRequire("70dwx");

var $aZDOo = parcelRequire("aZDOo");

var $kOFqu = parcelRequire("kOFqu");

var $a9Ugo = parcelRequire("a9Ugo");

var $27dcx = parcelRequire("27dcx");

var $lyHkj = parcelRequire("lyHkj");

var $eFtsB = parcelRequire("eFtsB");
class $69111d7a3efa4d05$export$2e2bcd8739ae039 extends (0, $eFtsB.default) {
    constructor(sAngle, onUpdate, onComp){
        super();
        const d = 800;
        const angle = Math.PI / 12;
        this.onUpdate = onUpdate;
        this.moveRedPoint(sAngle, angle, d, ()=>{
            this.moveRedPoint(sAngle + angle, -angle * 2, d * 2, ()=>{
                this.moveRedPoint(sAngle - angle, angle, d, ()=>onComp());
            });
        });
    }
    moveRedPoint(sAngle, angle, duration, onComp) {
        const a = {
            angle: sAngle
        };
        new (0, $lyHkj.default).Tween({
            ...a
        }).to({
            angle: sAngle + angle
        }, duration).easing((0, $lyHkj.default).Easing.Linear.None).onUpdate((a)=>{
            this.onUpdate(a.angle);
        }).onComplete(()=>onComp()).start();
    }
}



var $6MHFV = parcelRequire("6MHFV");

var $hL4lC = parcelRequire("hL4lC");

var $hP5lc = parcelRequire("hP5lc");
function $311ef2ef59963e46$export$e6a3879eeac1aa9d(pointsArr) {
    return new Promise((resolve)=>{
        pointsArr.forEach((point)=>{
            point.visible = true;
            point.scale = 0.2;
            new (0, $27dcx.default)(point, ()=>resolve());
        });
    });
}
function $311ef2ef59963e46$export$2707a00551b9d1cc(angle, value) {
    return new Promise((resolve)=>{
        angle.visible = true;
        angle.scale.set(0.3);
        new (0, $aZDOo.default)(angle, ()=>{
            angle.AngleValue.setValue(value);
            angle.AngleValue.visible = true;
            resolve();
        });
    });
}
function $311ef2ef59963e46$export$720cbfe21b054bd1(line, from, to) {
    return new Promise((resolve)=>{
        new (0, $a9Ugo.default)(line, from, to, resolve);
    });
}
function $311ef2ef59963e46$export$7e0882271c304db0(circle, radian, isClockwise, coord) {
    return new Promise((resolve)=>{
        new (0, $kOFqu.default)(circle, radian, 0, isClockwise, coord, ()=>resolve());
    });
}
function $311ef2ef59963e46$export$6f65ac6ef713080a(startRadian, callback) {
    return new Promise((resolve)=>{
        new (0, $69111d7a3efa4d05$export$2e2bcd8739ae039)(startRadian, callback, ()=>resolve());
    });
}
function $311ef2ef59963e46$export$6927aa2d8fee9fc5(sAngle, tAngle, callback, onComp = ()=>{}) {
    return new Promise((resolve)=>{
        new (0, $hP5lc.default)(sAngle, tAngle, callback, ()=>setTimeout(()=>{
                resolve();
                onComp();
            }, 600));
    });
}
function $311ef2ef59963e46$export$2798021cc33f6214(sAngleArr, tAngleArr, callback) {
    return new Promise((resolve)=>{
        tAngleArr.forEach(async (tAngle, tAIndex)=>{
            if (tAIndex < tAngleArr.length - 1) return $311ef2ef59963e46$export$6927aa2d8fee9fc5(sAngleArr[tAIndex], tAngle, (angle)=>callback(angle, tAIndex));
            await $311ef2ef59963e46$export$6927aa2d8fee9fc5(sAngleArr[tAIndex], tAngle, (angle)=>callback(angle, tAIndex), ()=>resolve());
        });
    });
}
function $311ef2ef59963e46$export$2f626a9a8b571038(calcLine) {
    return new Promise(()=>new (0, $hL4lC.default)(calcLine, .4, 1));
}
function $311ef2ef59963e46$export$9f98a19940c75aef(supplAngleLine) {
    return new Promise(()=>new (0, $hL4lC.default)(supplAngleLine, .4, 1));
}
function $311ef2ef59963e46$export$543c0984a55507b3(SliderManager) {
    return new Promise(()=>{
        SliderManager.setAllVisible(true);
        const sliders = SliderManager.getSliders();
        sliders.forEach((slider)=>new (0, $hL4lC.default)(slider, .3, 1));
    });
}
function $311ef2ef59963e46$export$f584aa9213fc042a(callback) {
    return new Promise((resolve)=>new (0, $6MHFV.default)(callback, 2, resolve));
}



async function $87ab60a44a60d526$export$792f2314b3a6e2b5(context, onComp) {
    const { circle: circle, LineManager: LineManager, PointManager: PointManager, PointTagManager: PointTagManager, AngleManager: AngleManager, SupplAngleManager: SupplAngleManager, CalcLineManager: CalcLineManager, SliderManager: SliderManager, cCoord: cCoord } = context;
    [
        AngleManager,
        SupplAngleManager,
        PointManager,
        PointTagManager,
        CalcLineManager,
        SliderManager
    ].forEach((manager)=>manager.setAllVisible(false));
    const [cSide1Point, cSide2Point, cSide3Point, cSide4Point] = PointManager.getRedPointsCoord();
    const RedPoints = PointManager.getRedPoints();
    const radians = PointManager.getRadians();
    const angles = AngleManager.getAngles();
    circle.setRadians([
        (0, $3e175ec0bdd08ea5$export$6d492146c93bd459)[0],
        (0, $3e175ec0bdd08ea5$export$6d492146c93bd459)[0]
    ]);
    await (0, $311ef2ef59963e46$export$7e0882271c304db0)(circle, (0, $3e175ec0bdd08ea5$export$6d492146c93bd459)[0] + Math.PI * 2, true, cCoord);
    await (0, $311ef2ef59963e46$export$720cbfe21b054bd1)(LineManager.line1, cSide1Point, cSide2Point);
    await (0, $311ef2ef59963e46$export$720cbfe21b054bd1)(LineManager.line2, cSide2Point, cSide3Point);
    await (0, $311ef2ef59963e46$export$720cbfe21b054bd1)(LineManager.line3, cSide3Point, cSide4Point);
    await (0, $311ef2ef59963e46$export$720cbfe21b054bd1)(LineManager.line4, cSide4Point, cSide1Point);
    (0, $311ef2ef59963e46$export$2707a00551b9d1cc)(angles[0], (0, $3e175ec0bdd08ea5$export$64436d1175f556d9).angle1);
    await (0, $311ef2ef59963e46$export$2707a00551b9d1cc)(angles[2], (0, $3e175ec0bdd08ea5$export$64436d1175f556d9).angle3);
    (0, $311ef2ef59963e46$export$2f626a9a8b571038)(CalcLineManager.firstCalcLine);
    (0, $311ef2ef59963e46$export$2707a00551b9d1cc)(angles[1], (0, $3e175ec0bdd08ea5$export$64436d1175f556d9).angle2);
    await (0, $311ef2ef59963e46$export$2707a00551b9d1cc)(angles[3], (0, $3e175ec0bdd08ea5$export$64436d1175f556d9).angle4);
    (0, $311ef2ef59963e46$export$2f626a9a8b571038)(CalcLineManager.secondCalcLine);
    await (0, $311ef2ef59963e46$export$e6a3879eeac1aa9d)(PointManager.getPoints());
    PointTagManager.setAllVisible(true);
    for(let index = 0; index < 2; index++){
        (0, $311ef2ef59963e46$export$6f65ac6ef713080a)(radians[index], (radian)=>PointManager.setRadian([
                {
                    pTag: RedPoints[index].tag,
                    radian: radian
                }
            ]));
        await (0, $311ef2ef59963e46$export$6f65ac6ef713080a)(radians[index + 2], (radian)=>PointManager.setRadian([
                {
                    pTag: RedPoints[index + 2].tag,
                    radian: radian
                }
            ]));
    }
    const pointAnimArr = [
        [
            -(2 * Math.PI) * 15 / 36,
            -(2 * Math.PI) * 3 / 36,
            -(2 * Math.PI) * 7 / 36,
            -(2 * Math.PI) * 10 / 36
        ],
        [
            2 * Math.PI * 10.5 / 36,
            2 * Math.PI * 6 / 36,
            2 * Math.PI * 3.5 / 36,
            2 * Math.PI * 17 / 36
        ],
        PointManager.getInitialRadians()
    ];
    for(let index = 0; index < pointAnimArr.length; index++){
        const arr = pointAnimArr[index];
        await (0, $311ef2ef59963e46$export$2798021cc33f6214)(radians, arr, (radian, index)=>PointManager.setRadian([
                {
                    pTag: RedPoints[index].tag,
                    radian: radian
                }
            ]));
    }
    (0, $311ef2ef59963e46$export$9f98a19940c75aef)(SupplAngleManager.SupplAngleLines[0]);
    (0, $311ef2ef59963e46$export$9f98a19940c75aef)(SupplAngleManager.SupplAngleLines[1]);
    (0, $311ef2ef59963e46$export$543c0984a55507b3)(SliderManager);
    onComp();
}
function $87ab60a44a60d526$export$220c3d2061e74c52(PointManager, radians, newRadians) {
    const RedPoints = PointManager.getRedPoints();
    (0, $311ef2ef59963e46$export$2798021cc33f6214)(radians, newRadians, (radian, index)=>PointManager.setRadian({
            pTag: RedPoints[index].tag,
            radian: radian
        }));
}


function $4692678572873962$export$4777bb8a9f19b87(PointManager, radians) {
    const newRadians = (0, $70dwx.getRandomUniqueNumbers)(4, 0, 23).map((v)=>v * (Math.PI / 12)).sort().reverse();
    (0, $87ab60a44a60d526$export$220c3d2061e74c52)(PointManager, radians, newRadians);
}


class $d2cad927508d1c62$export$2e2bcd8739ae039 extends (0, $2wguv.default) {
    constructor(){
        super((0, $3e175ec0bdd08ea5$export$c7609d9da8d80867), (0, $3e175ec0bdd08ea5$export$ca8f2c484d507a5d), (0, $3e175ec0bdd08ea5$export$6d492146c93bd459)), this.EventBus = (0, $cab198783107b617$export$5087227eb54526), this.pointCheckList = [], this.generateRandomShape = ()=>(0, $4692678572873962$export$4777bb8a9f19b87)(this, this.getRadians()), this.movePoints = (v)=>{
            const points = this.getRedPoints();
            const generateOffsetRadian = (v)=>Math.PI / 300 * v;
            const pointInfoArr = this.pointCheckList.map((e, eI)=>this.pointRefRadians[eI] + (e ? generateOffsetRadian(v) : 0)).map((r, rI)=>({
                    pTag: points[rI].tag,
                    radian: r
                }));
            this.setRadian(pointInfoArr, true);
        };
        this.EventBus.on((0, $cab198783107b617$export$cb883390c27ec6dd).setPointChecklist, (l)=>this.pointCheckList = l);
        this.EventBus.on((0, $cab198783107b617$export$cb883390c27ec6dd).generateRandomQuadri, ()=>this.generateRandomShape());
        this.EventBus.on((0, $cab198783107b617$export$cb883390c27ec6dd).setGrowCircleValue, (v)=>this.setGrowCircle(v));
        this.EventBus.on((0, $cab198783107b617$export$cb883390c27ec6dd).movePoints, (v)=>this.movePoints(v));
        this.EventBus.on((0, $cab198783107b617$export$cb883390c27ec6dd).setRadiansToRefs, ()=>this.pointRefRadians = [
                ...this.pointRadians
            ]);
    }
    setGrowCircle(v) {
        this.circleRadius = v / 5 + (0, $3e175ec0bdd08ea5$export$ca8f2c484d507a5d);
        this.setCoord();
    }
}



var $fbGgL = parcelRequire("fbGgL");
class $8f80008830dc4c2f$export$2e2bcd8739ae039 extends (0, $fbGgL.default) {
    constructor(cCoord){
        super(cCoord, [
            "A",
            "B",
            "C",
            "D"
        ]);
    }
}



var $etsqE = parcelRequire("etsqE");

function $aa02a377470f273f$export$2e2bcd8739ae039(pStart, pEnd, length) {
    const angle = Math.atan2(pStart.y - pEnd.y, pStart.x - pEnd.x);
    const p = {
        x: pStart.x + Math.cos(angle) * length,
        y: pStart.y + Math.sin(angle) * length
    };
    return [
        pStart,
        p
    ];
}


class $718704bf52949c9c$export$2e2bcd8739ae039 {
    constructor(){
        this.EventBus = (0, $cab198783107b617$export$5087227eb54526);
        this.isSuppMode = false;
        this.line1 = new (0, $etsqE.default)();
        this.line2 = new (0, $etsqE.default)();
        this.line3 = new (0, $etsqE.default)();
        this.line4 = new (0, $etsqE.default)();
        this.guideLine1 = new (0, $etsqE.default)({
            width: 3
        });
        this.guideLine2 = new (0, $etsqE.default)({
            width: 3
        });
        this.EventBus.on((0, $cab198783107b617$export$cb883390c27ec6dd).supplementaryMode, (v)=>this.isSuppMode = v);
    }
    draw([p1, p2, p3, p4]) {
        this.drawLines([
            p1,
            p2,
            p3,
            p4
        ]);
        this.isSuppMode && this.drawGuideLines([
            p1,
            p2,
            p3,
            p4
        ]);
    }
    drawLines([p1, p2, p3, p4]) {
        this.line1.draw(p1, p2);
        this.line2.draw(p2, p3);
        this.line3.draw(p3, p4);
        this.line4.draw(p4, p1);
    }
    drawGuideLines([p1, p2, p3, p4]) {
        const gl1 = (0, $aa02a377470f273f$export$2e2bcd8739ae039)(p2, p3, 120);
        const gl2 = (0, $aa02a377470f273f$export$2e2bcd8739ae039)(p3, p2, 120);
        this.guideLine1.draw(gl1[0], gl1[1]);
        this.guideLine2.draw(gl2[0], gl2[1]);
    }
    getGuideLinesCoords([p1, p2, p3, p4]) {
        return [
            (0, $aa02a377470f273f$export$2e2bcd8739ae039)(p2, p3, 120),
            (0, $aa02a377470f273f$export$2e2bcd8739ae039)(p3, p2, 120)
        ];
    }
}




var $9NMk5 = parcelRequire("9NMk5");


var $elBkP = parcelRequire("elBkP");


var $5ekDK = parcelRequire("5ekDK");

var $ahQvm = parcelRequire("ahQvm");
function $24b33088cb55f0bb$export$73935091fa556468(angle, p, degree, clockwise) {
    const { startRadian: startRadian, endRadian: endRadian } = (0, $5ekDK.default)(p.curr, p.prev, p.next);
    const smllDistance = Math.min((0, $elBkP.default)(p.curr, p.prev), (0, $elBkP.default)(p.curr, p.next));
    angle.smallDistance = Math.floor(smllDistance);
    angle.draw(p.curr, startRadian, endRadian, degree, clockwise);
    angle.x = p.curr.x;
    angle.y = p.curr.y;
    angle.rotation = 0;
}
function $24b33088cb55f0bb$export$39ecf6e52a70201b(supplAngle, p, degree, clockwise, isFirst) {
    const { startRadian: startRadian, endRadian: endRadian } = (0, $5ekDK.default)(p.curr, p.prev, p.next);
    $24b33088cb55f0bb$export$73935091fa556468(supplAngle, p, degree, clockwise);
    supplAngle.x = supplAngle.coord.x;
    supplAngle.y = supplAngle.coord.y;
    supplAngle.AngleValue.visible = false;
    supplAngle.rotation = isFirst ? Math.PI - startRadian : 0 - endRadian;
}
function $24b33088cb55f0bb$export$ad3ca434770b077d(angle1, angle4, degrees, [p1, p2, p3, p4], clockwise) {
    const points = (0, $aa02a377470f273f$export$2e2bcd8739ae039)(p3, p2, 200);
    const points1 = (0, $aa02a377470f273f$export$2e2bcd8739ae039)(p2, p3, 200);
    const p = {
        curr: p3,
        prev: p4,
        next: points[1]
    };
    const pt1 = {
        curr: p2,
        prev: p1,
        next: points1[1]
    };
    const anglef = (0, $ahQvm.generateAngles)(p, clockwise);
    const angles = (0, $ahQvm.generateAngles)(pt1, clockwise);
    $24b33088cb55f0bb$export$73935091fa556468(angle1, p, degrees[0], clockwise);
    $24b33088cb55f0bb$export$73935091fa556468(angle4, pt1, degrees[1], !clockwise);
}


function $8ef098741c39e24d$export$5f61282e9abe72d5(pointArr) {
    return pointArr.map((p, pI)=>{
        const prevP = pointArr[pI == 0 ? pointArr.length - 1 : pI - 1];
        const nextP = pointArr[pI == pointArr.length - 1 ? 0 : pI + 1];
        return {
            curr: p,
            prev: prevP,
            next: nextP
        };
    });
}



var $5yG2B = parcelRequire("5yG2B");
class $eea5c905cdd73549$export$2e2bcd8739ae039 {
    constructor(){
        this.EventBus = (0, $cab198783107b617$export$5087227eb54526);
        this.angles = (0, $3e175ec0bdd08ea5$export$853e2ffa6cb8f5fa).map((color, colorI)=>new (0, $9NMk5.default)(`a${colorI + 1}`, {
                color: color,
                textColor: color
            }, 44));
        this.isSuppMode = false;
        this.currAngles = [];
        this.emitAngles = (degrees)=>this.EventBus.emit((0, $cab198783107b617$export$cb883390c27ec6dd).setCalcLines, degrees);
        this.getAngles = ()=>this.angles;
        this.drawGuideAngle = (pArr, degrees)=>(0, $24b33088cb55f0bb$export$ad3ca434770b077d)(this.angles[0], this.angles[3], degrees, pArr, false);
        this.EventBus.on((0, $cab198783107b617$export$cb883390c27ec6dd).supplementaryMode, (v)=>this.isSuppMode = v);
    }
    setAllVisible(v) {
        this.angles.forEach((angle)=>angle.setVisible(v));
    }
    draw(pointArr, clockwise) {
        const points = (0, $8ef098741c39e24d$export$5f61282e9abe72d5)(pointArr);
        const angle1 = (0, $5yG2B.default)(points[0].prev, points[0].curr, points[0].next);
        const angle2 = (0, $5yG2B.default)(points[1].prev, points[1].curr, points[1].next);
        const degrees = [
            angle1,
            angle2,
            180 - angle1,
            180 - angle2
        ];
        points.forEach((p, pI)=>(0, $24b33088cb55f0bb$export$73935091fa556468)(this.angles[pI], p, degrees[pI], clockwise));
        this.isSuppMode && this.drawGuideAngle(pointArr, [
            degrees[0],
            degrees[3]
        ]);
        this.emitAngles(Array(4).fill(null).map((_, i)=>degrees[i]));
    }
}



var $d55ji = parcelRequire("d55ji");

var $83ZZo = parcelRequire("83ZZo");

var $9e8jK = parcelRequire("9e8jK");

var $9NMk5 = parcelRequire("9NMk5");
class $94d70f6a9cec4e6a$export$2e2bcd8739ae039 extends $83ZZo.Container {
    constructor(coord, tags, colors){
        super(), this.Layers = (0, $9e8jK.default).getInstance(), this.getSupplAngle = ()=>this.supplAngles, this.addToLayer = ()=>this.Layers.Info.addChild(this), this.setVisible = (v)=>{
            this.visible = v;
            this.supplAngles.forEach((angle)=>angle.visible = v);
        };
        Object.assign(this, coord);
        this.addAngles(colors, tags);
        this.addSymbols();
        this.addToLayer();
    }
    addAngles(colors, tags) {
        this.supplAngles = [
            -70,
            0,
            100,
            100
        ].map((x, xI)=>{
            const sAngle = new $94d70f6a9cec4e6a$export$ab9a537db157d0c5({
                x: x,
                y: 0
            }, tags[xI], colors[xI % 2]);
            this.addChild(sAngle);
            return sAngle;
        });
    }
    addSymbols() {
        const xs = [
            -30,
            50
        ];
        const symbols = [
            "+",
            "="
        ].map((t, tI)=>{
            const text = new $83ZZo.Text({
                text: t
            });
            text.style.fontSize = 35;
            text.x = xs[tI];
            text.anchor.set(.5, .8);
            this.addChild(text);
            return text;
        });
    }
}
class $94d70f6a9cec4e6a$export$ab9a537db157d0c5 extends (0, $9NMk5.default) {
    constructor(coord, tag, color){
        super(tag, {
            color: color,
            textColor: 0x000000
        }, -100, true);
        this.coord = coord;
        this.scale.set(.5);
    }
}




var $3JQTS = parcelRequire("3JQTS");



var $ahQvm = parcelRequire("ahQvm");

class $fe01d1a7690df3a2$export$2e2bcd8739ae039 {
    constructor(){
        this.Game = (0, $d55ji.default).getInstance();
        this.RootEventBus = (0, $3JQTS.RootEventBus);
        this.EventBus = (0, $cab198783107b617$export$5087227eb54526);
        this.setAllVisible = (v)=>this.SupplAngleLines.forEach((l)=>l.setVisible(v));
        this.addSupplAngles();
        this.RootEventBus.on((0, $3JQTS.EnumRootEventBus).completedIntroAnim, ()=>this.setAllVisible(true));
    }
    isVertical() {
        const dim = this.Game.getDim();
        return dim.WIDTH < dim.HEIGHT;
    }
    generateCoords() {
        const isVertical = this.isVertical();
        const dim = this.Game.getDim();
        let coords = [
            {
                x: 150,
                y: 350
            },
            {
                x: 150,
                y: 400
            }
        ];
        if (isVertical) coords = [
            {
                x: dim.WIDTH / 2 - 215,
                y: dim.HEIGHT / 2 + 250
            },
            {
                x: dim.WIDTH / 2 + 185,
                y: dim.HEIGHT / 2 + 250
            }
        ];
        return coords;
    }
    addSupplAngles() {
        const coords = this.generateCoords();
        const l1 = new (0, $94d70f6a9cec4e6a$export$2e2bcd8739ae039)(coords[0], [
            "sa-1",
            "sa-3",
            "sat-1",
            "sat-3"
        ], [
            (0, $3e175ec0bdd08ea5$export$853e2ffa6cb8f5fa)[0],
            (0, $3e175ec0bdd08ea5$export$853e2ffa6cb8f5fa)[2]
        ]);
        const l2 = new (0, $94d70f6a9cec4e6a$export$2e2bcd8739ae039)(coords[1], [
            "sa-2",
            "sa-4",
            "sat-2",
            "sat-4"
        ], [
            (0, $3e175ec0bdd08ea5$export$853e2ffa6cb8f5fa)[1],
            (0, $3e175ec0bdd08ea5$export$853e2ffa6cb8f5fa)[3]
        ]);
        const angles = [
            l1.getSupplAngle(),
            l2.getSupplAngle()
        ];
        this.SupplAngleLines = [
            l1,
            l2
        ];
        this.SupplAngles = [
            angles[0][0],
            angles[1][0],
            angles[0][1],
            angles[1][1]
        ];
        this.SupplAnglesTotal = [
            angles[0][2],
            angles[1][2],
            angles[0][3],
            angles[1][3]
        ];
    }
    draw(pointArr, clockwise) {
        const points = (0, $8ef098741c39e24d$export$5f61282e9abe72d5)(pointArr);
        const degree1 = (0, $ahQvm.generateAngles)(points[0], clockwise).degree;
        const degree2 = (0, $ahQvm.generateAngles)(points[1], clockwise).degree;
        const degrees = [
            degree1,
            degree2,
            180 - degree1,
            180 - degree2
        ];
        pointArr.forEach((p, pI)=>{
            const prevP = pointArr[pI == 0 ? pointArr.length - 1 : pI - 1];
            const nextP = pointArr[pI == pointArr.length - 1 ? 0 : pI + 1];
            (0, $24b33088cb55f0bb$export$39ecf6e52a70201b)(this.SupplAngles[pI], {
                curr: p,
                prev: prevP,
                next: nextP
            }, degrees[pI], clockwise, pI < 2);
            (0, $24b33088cb55f0bb$export$39ecf6e52a70201b)(this.SupplAnglesTotal[pI], {
                curr: p,
                prev: prevP,
                next: nextP
            }, degrees[pI], clockwise, pI < 2);
        });
    }
}





var $3JQTS = parcelRequire("3JQTS");
class $c41be5edc49c93f3$export$2e2bcd8739ae039 {
    constructor(PointManager, PointTagManager, AngleManager, SupplAngleManager, LineManager, SliderManager, CalcLineManager, circle, cCoord){
        this.PointManager = PointManager;
        this.PointTagManager = PointTagManager;
        this.AngleManager = AngleManager;
        this.SupplAngleManager = SupplAngleManager;
        this.LineManager = LineManager;
        this.SliderManager = SliderManager;
        this.CalcLineManager = CalcLineManager;
        this.circle = circle;
        this.cCoord = cCoord;
        this.RootEventBus = (0, $3JQTS.RootEventBus);
        this.EventBus = (0, $cab198783107b617$export$5087227eb54526);
        this.drawAngles = (rPointsCoord, isbtw)=>this.AngleManager.draw(rPointsCoord, isbtw);
        this.drawAngles(this.PointManager.getRedPointsCoord(), false);
    }
    runAnimations() {
        this.EventBus.emit((0, $cab198783107b617$export$cb883390c27ec6dd).setElementsForAnim, false);
        (0, $87ab60a44a60d526$export$792f2314b3a6e2b5)(this, ()=>{
            this.RootEventBus.emit((0, $3JQTS.EnumRootEventBus).getCircleCoord, {
                x: this.circle.x,
                y: this.circle.y
            });
            this.RootEventBus.emit((0, $3JQTS.EnumRootEventBus).completedIntroAnim);
        });
    }
}



var $d55ji = parcelRequire("d55ji");

var $83ZZo = parcelRequire("83ZZo");

var $9e8jK = parcelRequire("9e8jK");
class $88ba8a3350206fbc$export$2e2bcd8739ae039 extends $83ZZo.Text {
    constructor(coord, color, initialVals){
        super(), this.Layers = (0, $9e8jK.default).getInstance(), this.generateText = (degree1, degree2)=>`${degree1}\xb0 + ${degree2}\xb0 ${degree1 + degree2 == 180 ? "=" : "\u2260"} 180\xb0`;
        Object.assign(this, coord);
        this.addText(color);
        this.text = `${initialVals[0]}\xb0 + ${initialVals[1]}\xb0 = 180\xb0`;
        this.addToLayer();
    }
    addText(color) {
        this.text = "x\xb0 + y\xb0 = 180\xb0";
        this.style.fontWeight = "600";
        this.style.fill = color;
        this.style.fontSize = 40;
        this.anchor.set(1);
    }
    updateDegrees(degree1, degree2) {
        this.text = this.generateText(degree1, degree2);
    }
    addToLayer() {
        this.Layers.Info.addChild(this);
    }
}



var $99f70 = parcelRequire("99f70");


var $3JQTS = parcelRequire("3JQTS");

class $3aa61085cadb292a$export$2e2bcd8739ae039 {
    constructor(isVertical){
        this.Game = (0, $d55ji.default).getInstance();
        this.RootEventBus = (0, $3JQTS.RootEventBus);
        this.EventBus = (0, $cab198783107b617$export$5087227eb54526);
        this.isCompletedIntroAnim = true;
        this.generateCalcLines(isVertical);
        this.EventBus.on((0, $cab198783107b617$export$cb883390c27ec6dd).setCalcLines, (degrees)=>this.setDegrees(degrees));
        this.RootEventBus.on((0, $3JQTS.EnumRootEventBus).completedIntroAnim, ()=>this.isCompletedIntroAnim = true);
    }
    generateCalcLines(isVertical) {
        const dim = this.Game.getDim();
        const verticalCoords = [
            {
                x: dim.WIDTH / 2 - 50,
                y: dim.HEIGHT / 2 + 200
            },
            {
                x: dim.WIDTH / 2 + 350,
                y: dim.HEIGHT / 2 + 200
            }
        ];
        const coords = isVertical ? verticalCoords : (0, $3e175ec0bdd08ea5$export$f64a627e96c12fc8);
        this.firstCalcLine = new (0, $88ba8a3350206fbc$export$2e2bcd8739ae039)(coords[0], (0, $99f70.CENTER_ANGLE_COLOR).textColor, [
            "a",
            "c"
        ]);
        this.secondCalcLine = new (0, $88ba8a3350206fbc$export$2e2bcd8739ae039)(coords[1], (0, $99f70.CIRCUM_ANGLE_COLOR).textColor, [
            "b",
            "d"
        ]);
    }
    setDegrees(degrees) {
        if (!this.isCompletedIntroAnim) return;
        this.firstCalcLine.updateDegrees(degrees[0], degrees[2]);
        this.secondCalcLine.updateDegrees(degrees[1], degrees[3]);
    }
    setAllVisible(v) {
        this.firstCalcLine.visible = v;
        this.secondCalcLine.visible = v;
    }
    setVisible(index, v) {
        if (index == 0) this.firstCalcLine.visible = v;
        else if (index == 1) this.secondCalcLine.visible = v;
    }
}



var $cbvsj = parcelRequire("cbvsj");


var $gErQO = parcelRequire("gErQO");

const $b29a4d078fd2d3f9$var$SliderGen = [
    {
        head: "grow shape",
        colors: {
            bgColor: 0x21D4FE,
            barColor: 0x000000,
            buttonColor: 0x21D4FE
        },
        onUpdate: (v)=>(0, $cab198783107b617$export$5087227eb54526).emit((0, $cab198783107b617$export$cb883390c27ec6dd).setGrowCircleValue, v - 100)
    },
    {
        head: "move the points",
        subHead: "(select which on the right)",
        colors: {
            bgColor: 0xBFBFBF,
            barColor: 0x000000,
            buttonColor: 0x000000
        },
        onUpdate: (v)=>(0, $cab198783107b617$export$5087227eb54526).emit((0, $cab198783107b617$export$cb883390c27ec6dd).movePoints, v - 100)
    }
];
const $b29a4d078fd2d3f9$var$pointName = [
    "point A",
    "point B",
    "point C",
    "point D"
];
class $b29a4d078fd2d3f9$export$2e2bcd8739ae039 extends (0, $cbvsj.default) {
    constructor(){
        super($b29a4d078fd2d3f9$var$SliderGen, (0, $3e175ec0bdd08ea5$export$186dbbe504e85fe1), (0, $3e175ec0bdd08ea5$export$75f2cc8245aafe09)), this.EventBus = (0, $cab198783107b617$export$5087227eb54526), this.pointCheckboxs = [], this.pointChecklist = Array(4).fill(false);
        this.checkVertical();
        this.RootEventBus.on(this.EnumRootEventBus.completedIntroAnim, ()=>this.addCheckBoxs());
    }
    checkVertical() {
        if (this.dim.WIDTH < this.dim.HEIGHT) {
            console.log("sadasdads");
            const slider = this.sliders[0];
            this.sliders.shift();
            slider.visible = false;
        }
    }
    handleCheckbox(label, v) {
        this.pointChecklist[$b29a4d078fd2d3f9$var$pointName.indexOf(label)] = v;
        this.EventBus.emit((0, $cab198783107b617$export$cb883390c27ec6dd).setPointChecklist, this.pointChecklist);
    }
    addCheckBoxs() {
        const coords = $b29a4d078fd2d3f9$var$getPointCheckboxCoords(this.dim);
        this.pointCheckboxs = (0, $3e175ec0bdd08ea5$export$853e2ffa6cb8f5fa).map((e, eI)=>new (0, $gErQO.default)(coords[eI], $b29a4d078fd2d3f9$var$pointName[eI], e, false, (label, v)=>this.handleCheckbox(label, v)));
        this.dim.WIDTH < this.dim.HEIGHT && this.pointCheckboxs.forEach((cbox)=>cbox.scale.set(.8));
    }
}
function $b29a4d078fd2d3f9$var$getPointCheckboxCoords(dim) {
    const getCoordHorizontal = (eI)=>({
            x: 1185 + (eI > 1 ? 180 : 0),
            y: 775 + (eI % 2 == 1 ? 50 : 0)
        });
    const getCoordVertical = (eI)=>({
            x: dim.WIDTH / 2 + 35 + (eI > 1 ? 150 : 0),
            y: dim.HEIGHT / 2 + 500 + (eI % 2 == 1 ? 40 : 0)
        });
    const coords = Array(4).fill(null).map((e, eI)=>dim.WIDTH > dim.HEIGHT ? getCoordHorizontal(eI) : getCoordVertical(eI));
    return coords;
}




var $lyHkj = parcelRequire("lyHkj");

var $eFtsB = parcelRequire("eFtsB");
class $f5572b8d9ec58ab0$export$2e2bcd8739ae039 extends (0, $eFtsB.default) {
    constructor(Line, pCoord, sCoord, tCoord, onComp){
        super(), this.pCoord = pCoord, this.sCoord = sCoord, this.tCoord = tCoord;
        new (0, $lyHkj.default).Tween({
            ...sCoord
        }).to({
            x: tCoord.x,
            y: tCoord.y
        }, 1000).easing((0, $lyHkj.default).Easing.Linear.None).onUpdate((coord)=>{
            Line.draw(pCoord, coord);
        }).onComplete(()=>onComp()).start();
    }
}



var $lyHkj = parcelRequire("lyHkj");

var $eFtsB = parcelRequire("eFtsB");
class $29684bf77e97bd48$export$2e2bcd8739ae039 extends (0, $eFtsB.default) {
    constructor(Angle, tCoord, onComp = ()=>{}){
        super();
        new (0, $lyHkj.default).Tween(Angle).to(tCoord, 1200).easing((0, $lyHkj.default).Easing.Linear.None).onComplete(()=>onComp()).start();
    }
}



var $lyHkj = parcelRequire("lyHkj");

var $eFtsB = parcelRequire("eFtsB");
class $6dd58bbf6ceff0f5$export$2e2bcd8739ae039 extends (0, $eFtsB.default) {
    constructor(Point, visible, onComp){
        super();
        const tS = visible ? 1 : .3;
        visible && (Point.visible = true);
        new (0, $lyHkj.default).Tween(Point.scale).to({
            x: tS,
            y: tS
        }, 300).easing((0, $lyHkj.default).Easing.Linear.None).onComplete(()=>{
            Point.visible = visible;
            onComp();
        }).start();
    }
}



var $lyHkj = parcelRequire("lyHkj");

var $eFtsB = parcelRequire("eFtsB");
class $a8ee3ae9ad430b9b$export$2e2bcd8739ae039 extends (0, $eFtsB.default) {
    constructor(angle, rotation, delay, onComp){
        super();
        new (0, $lyHkj.default).Tween(angle).to({
            rotation: rotation
        }, 500).delay(delay).onComplete(()=>onComp()).start();
    }
}


function $5b8663146e5e6f98$export$3a775ef3f2639103(pointArr, visible) {
    return new Promise((resolve)=>{
        pointArr.forEach((point)=>{
            point.visible = true;
            point.scale = 0.2;
            new (0, $6dd58bbf6ceff0f5$export$2e2bcd8739ae039)(point, visible, ()=>resolve());
        });
    });
}
function $5b8663146e5e6f98$export$74d7a69a4127e6bc(guideLines, lC, isReverse) {
    return new Promise((resolve)=>{
        guideLines.forEach((guideLine, gI)=>{
            const pCoord = lC[gI][0];
            const sCoord = isReverse ? lC[gI][1] : lC[gI][0];
            const tCoord = isReverse ? lC[gI][0] : lC[gI][1];
            new (0, $f5572b8d9ec58ab0$export$2e2bcd8739ae039)(guideLine, pCoord, sCoord, tCoord, ()=>resolve());
        });
    });
}
function $5b8663146e5e6f98$export$650c6fb8e1a8ad1a(angles, points) {
    return new Promise((resolve)=>{
        angles.forEach((angle, aI)=>{
            new (0, $29684bf77e97bd48$export$2e2bcd8739ae039)(angle, points[aI], ()=>resolve());
        });
    });
}
function $5b8663146e5e6f98$export$cc31dc8840bfd545(angles, rotations) {
    return new Promise((resolve)=>{
        angles.forEach((angle, aI)=>{
            new (0, $a8ee3ae9ad430b9b$export$2e2bcd8739ae039)(angle, rotations[aI], 300, ()=>resolve());
        });
    });
}


function $936b5d4144bbaa6d$export$17da8f6ce3aa1c5d(context, isActive, cb) {
    if (isActive) $936b5d4144bbaa6d$export$84387efe5e3837ca(context, cb);
    else $936b5d4144bbaa6d$export$d64178aba196494(context, cb);
}
async function $936b5d4144bbaa6d$export$84387efe5e3837ca(context, cb) {
    const { LineManager: LineManager, PointManager: PointManager, AngleManager: AngleManager } = context;
    const redPoints = PointManager.getRedPoints();
    const pointCoords = redPoints.map((r)=>({
            x: r.x,
            y: r.y
        }));
    const angles = AngleManager.getAngles();
    const lC = LineManager.getGuideLinesCoords(pointCoords);
    const rots = [
        -Math.PI / 180 * angles[3].degree,
        Math.PI / 180 * angles[0].degree
    ];
    await (0, $5b8663146e5e6f98$export$3a775ef3f2639103)([
        redPoints[0],
        redPoints[3]
    ], false);
    await (0, $5b8663146e5e6f98$export$74d7a69a4127e6bc)([
        LineManager.guideLine1,
        LineManager.guideLine2
    ], lC, false);
    await (0, $5b8663146e5e6f98$export$650c6fb8e1a8ad1a)([
        angles[0],
        angles[3]
    ], [
        pointCoords[2],
        pointCoords[1]
    ]);
    await (0, $5b8663146e5e6f98$export$cc31dc8840bfd545)([
        angles[0],
        angles[3]
    ], rots);
    cb();
}
async function $936b5d4144bbaa6d$export$d64178aba196494(context, cb) {
    const { LineManager: LineManager, PointManager: PointManager, AngleManager: AngleManager } = context;
    const redPoints = PointManager.getRedPoints();
    const pointCoords = redPoints.map((r)=>({
            x: r.x,
            y: r.y
        }));
    const angles = AngleManager.getAngles();
    const lC = LineManager.getGuideLinesCoords(pointCoords);
    const _rots = [
        -Math.PI / 180 * angles[3].degree,
        Math.PI / 180 * angles[0].degree
    ];
    const rots = angles[0].rotation == 0 && angles[3].rotation == 0 ? _rots : [
        0,
        0
    ];
    await (0, $5b8663146e5e6f98$export$650c6fb8e1a8ad1a)([
        angles[0],
        angles[3]
    ], [
        pointCoords[0],
        pointCoords[3]
    ]);
    await (0, $5b8663146e5e6f98$export$cc31dc8840bfd545)([
        angles[0],
        angles[3]
    ], rots);
    await (0, $5b8663146e5e6f98$export$74d7a69a4127e6bc)([
        LineManager.guideLine1,
        LineManager.guideLine2
    ], lC, true);
    await (0, $5b8663146e5e6f98$export$3a775ef3f2639103)([
        redPoints[0],
        redPoints[3]
    ], true);
    cb();
}


class $eb48dee5703ff294$export$2e2bcd8739ae039 {
    constructor(PointManager, AngleManager, LineManager){
        this.PointManager = PointManager;
        this.AngleManager = AngleManager;
        this.LineManager = LineManager;
        this.EventBus = (0, $cab198783107b617$export$5087227eb54526);
    }
    runAnimation(isActive) {
        (0, $936b5d4144bbaa6d$export$17da8f6ce3aa1c5d)(this, isActive, ()=>{
            this.EventBus.emit((0, $cab198783107b617$export$cb883390c27ec6dd).supplementaryMode, isActive);
        });
    }
}




var $3JQTS = parcelRequire("3JQTS");

var $83ZZo = parcelRequire("83ZZo");

var $d55ji = parcelRequire("d55ji");

var $9e8jK = parcelRequire("9e8jK");

var $hvh3T = parcelRequire("hvh3T");


var $3JQTS = parcelRequire("3JQTS");
class $6e5495667c6e20dd$export$2e2bcd8739ae039 extends $83ZZo.Container {
    constructor(coord, _handleFunc){
        super(), this.Game = (0, $d55ji.default).getInstance(), this.Layers = (0, $9e8jK.default).getInstance(), this.RootEventBus = (0, $3JQTS.RootEventBus), this.EventBus = (0, $cab198783107b617$export$5087227eb54526), this.addToLayer = ()=>this.Layers.UI.addChild(this), this.setVisible = (v)=>[
                this,
                this.SupplModeSwitcher
            ].forEach((e)=>e.visible = v), this.setSuppInteractivity = (v)=>this.SupplModeSwitcher.interactive = v, this.handleFunc = (isActive)=>{
            this._handleFunc(isActive);
            this.setSuppInteractivity(false);
        };
        this.setCoord(coord);
        this._handleFunc = _handleFunc;
        this.addSupplModeSwitcher();
        this.addHead();
        this.addToLayer();
        this.setVisible(false);
        this.EventBus.on((0, $cab198783107b617$export$cb883390c27ec6dd).supplementaryMode, ()=>this.setSuppInteractivity(true));
        this.RootEventBus.on((0, $3JQTS.EnumRootEventBus).completedIntroAnim, ()=>this.setVisible(true));
    }
    isVertical() {
        const dim = this.Game.getDim();
        return dim.WIDTH < dim.HEIGHT;
    }
    setCoord(coord) {
        const isVertical = this.isVertical();
        const dim = this.Game.getDim();
        let Coord = coord;
        if (isVertical) {
            const vcoord = {
                x: dim.WIDTH / 2 - 200,
                y: dim.HEIGHT / 2 + 560
            };
            Coord = vcoord;
        }
        Object.assign(this, Coord);
    }
    addHead() {
        const head = new $83ZZo.Text({
            text: "Supplementary Visual"
        });
        head.style = {
            fontWeight: "500",
            wordWrap: true,
            wordWrapWidth: 100,
            align: "center"
        };
        head.anchor.set(.5);
        head.y = -53;
        this.addChild(head);
    }
    addSupplModeSwitcher() {
        const isVertical = this.isVertical();
        this.SupplModeSwitcher = new (0, $hvh3T.default)(0x55E39F, this.handleFunc, true);
        this.SupplModeSwitcher.scale.set(isVertical ? 1.9 : 1.3);
        this.SupplModeSwitcher.y = isVertical ? 10 : 0;
        this.addChild(this.SupplModeSwitcher);
    }
}



var $d55ji = parcelRequire("d55ji");

var $l5XQj = parcelRequire("l5XQj");


var $3JQTS = parcelRequire("3JQTS");

const $50c88724269b1c1d$var$ButtonStyle = {
    width: 280,
    height: 120,
    wordWrapWidth: 160,
    defaultColor: 0xCECECE,
    hoverColor: 0xDEDEDE,
    pressedColor: 0xC5C5C5,
    borderColor: 0x111111,
    titleColor: 0x111111,
    titleFontSize: 28,
    borderRadius: 22
};
class $50c88724269b1c1d$export$2e2bcd8739ae039 extends (0, $l5XQj.default) {
    constructor(){
        super("Generate Random Quadrilateral", $50c88724269b1c1d$var$ButtonStyle, ()=>this.createRandomQuadri()), this.Game = (0, $d55ji.default).getInstance(), this.RootEventBus = (0, $3JQTS.RootEventBus), this.EventBus = (0, $cab198783107b617$export$5087227eb54526), this.createRandomQuadri = ()=>this.EventBus.emit((0, $cab198783107b617$export$cb883390c27ec6dd).generateRandomQuadri), this.setVisible = (v)=>this.visible = v;
        this.addCoord();
        this.setVisible(false);
        this.RootEventBus.on((0, $3JQTS.EnumRootEventBus).completedIntroAnim, ()=>this.setVisible(true));
    }
    addCoord() {
        const dim = this.Game.getDim();
        if (dim.WIDTH > dim.HEIGHT) {
            this.x = (0, $3e175ec0bdd08ea5$export$1312ecbb29a79419).x;
            this.y = (0, $3e175ec0bdd08ea5$export$1312ecbb29a79419).y;
            return;
        }
        this.x = dim.WIDTH / 2 - 200;
        this.y = dim.HEIGHT / 2 + 400;
    }
}


class $7f77fefc9deceecc$export$2e2bcd8739ae039 {
    constructor(){
        this.Game = (0, $d55ji.default).getInstance();
        this.RootEventBus = (0, $3JQTS.RootEventBus);
        this.cRadius = (0, $3e175ec0bdd08ea5$export$ca8f2c484d507a5d);
        this.cCoord = (0, $3e175ec0bdd08ea5$export$c7609d9da8d80867);
        this.infoSlider = new (0, $dF6vz.default)((0, $3e175ec0bdd08ea5$export$840ec2322406bfdd), (0, $3e175ec0bdd08ea5$export$4697ad01a4a84996));
        if (!$7f77fefc9deceecc$export$2e2bcd8739ae039.instance) $7f77fefc9deceecc$export$2e2bcd8739ae039.instance = this;
        const isVertical = this.isVertical();
        this.PointManager = new (0, $d2cad927508d1c62$export$2e2bcd8739ae039)();
        const radians = this.PointManager.getRadians();
        this.circle = new (0, $jG160.default)(this.cCoord, radians, Array(4).fill(0x000000));
        this.PointTagManager = new (0, $8f80008830dc4c2f$export$2e2bcd8739ae039)(this.cCoord);
        this.LineManager = new (0, $718704bf52949c9c$export$2e2bcd8739ae039)();
        this.AngleManager = new (0, $eea5c905cdd73549$export$2e2bcd8739ae039)();
        this.SupplAngleManager = new (0, $fe01d1a7690df3a2$export$2e2bcd8739ae039)();
        this.CalcLineManager = new (0, $3aa61085cadb292a$export$2e2bcd8739ae039)(isVertical);
        this.SliderManager = new (0, $b29a4d078fd2d3f9$export$2e2bcd8739ae039)();
        this.IntroAnimationManager = new (0, $c41be5edc49c93f3$export$2e2bcd8739ae039)(this.PointManager, this.PointTagManager, this.AngleManager, this.SupplAngleManager, this.LineManager, this.SliderManager, this.CalcLineManager, this.circle, this.cCoord);
        new (0, $6DjBJ.default)();
        const supp = new (0, $eb48dee5703ff294$export$2e2bcd8739ae039)(this.PointManager, this.AngleManager, this.LineManager);
        new (0, $6e5495667c6e20dd$export$2e2bcd8739ae039)({
            x: 160,
            y: 300
        }, (isActive)=>supp.runAnimation(isActive));
        new (0, $50c88724269b1c1d$export$2e2bcd8739ae039)();
        this.RootEventBus.on((0, $3JQTS.EnumRootEventBus).drawElements, ()=>this.drawElements());
        this.IntroAnimationManager.runAnimations();
    }
    static{
        this.getInstance = ()=>$7f77fefc9deceecc$export$2e2bcd8739ae039.instance;
    }
    isVertical() {
        const dim = this.Game.getDim();
        if (dim.WIDTH > dim.HEIGHT) return false;
        this.cCoord.x = dim.WIDTH / 2;
        this.cCoord.y = dim.HEIGHT / 2 - 100;
        return true;
    }
    drawElements() {
        const radians = this.PointManager.getRadians();
        const radius = this.PointManager.circleRadius;
        const redPointsCoord = this.PointManager.getRedPointsCoord();
        this.PointManager.draw();
        this.circle.draw({
            radians: [
                radians[1],
                radians[0]
            ],
            radius: radius
        });
        this.LineManager.draw(redPointsCoord);
        this.AngleManager.draw(redPointsCoord, false);
        this.SupplAngleManager.draw(redPointsCoord, false);
        this.PointTagManager.updateCoord(radians, radius + 30);
    }
}



const $9e400dd41e9f6a54$var$canvas = document.querySelector("#canvas");
if ($9e400dd41e9f6a54$var$canvas) window.context = new (0, $d55ji.default)($9e400dd41e9f6a54$var$canvas, (0, $3e175ec0bdd08ea5$export$4697ad01a4a84996), ()=>new (0, $7f77fefc9deceecc$export$2e2bcd8739ae039)());
else console.error("Canvas is not found");


//# sourceMappingURL=index.29f1ae2a.js.map
